/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { useState, useEffect, useCallback } from 'react';
import { timezoneService, Timezone } from '../services/timezoneService';

export const useTimezones = () => {
	const [timezones, setTimezones] = useState<Timezone[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchTimezones = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);

			const data = await timezoneService.getAllTimezones();
			setTimezones(data);
		} catch (err: any) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchTimezones();
	}, [fetchTimezones]);

	return {
		timezones,
		loading,
		error,
		refetch: fetchTimezones,
	};
};
